
const SET_MESSAGE = "SET_MESSAGE";
const SEND_MESSAGE = "SEND_MESSAGE";
const TOGGLE_PRELOADER = "dialogs/TOGGLE_PRELOADER";
const SET_ACTIVE_USER = "SET_ACTIVE_USER";

let initialState = {
    usersMessage: [
        {id: 1, name: "Вин Бензин", img: "https://steamuserimages-a.akamaihd.net/ugc/775113851241543716/7335FB32DB2BF8385B916C647F93725B90B5535B/?imw=512&amp;imh=512&amp;ima=fit&amp;impolicy=Letterbox&amp;imcolor=%23000000&amp;letterbox=true"},
        {id: 2, name: "Миша Тинькоф", img: "https://avatars.mds.yandex.net/get-pdb/1350656/1551285a-c152-405f-9336-798ec54b07a9/s1200"},
        {id: 3, name: "Ник Анистон", img: "https://avatars.mds.yandex.net/get-pdb/1649566/19e74635-4319-4587-89bf-68bbf6c122ae/s1200?webp=false"},
        {id: 4, name: "Ликер Иванович", img: "https://steamuserimages-a.akamaihd.net/ugc/775113851241543716/7335FB32DB2BF8385B916C647F93725B90B5535B/?imw=512&amp;imh=512&amp;ima=fit&amp;impolicy=Letterbox&amp;imcolor=%23000000&amp;letterbox=true"},
        {id: 5, name: "Игорь Пушкович", img: "https://avatars.mds.yandex.net/get-pdb/1350656/1551285a-c152-405f-9336-798ec54b07a9/s1200"},
        {id: 6, name: "Роберт Ап", img: "https://avatars.mds.yandex.net/get-pdb/1649566/19e74635-4319-4587-89bf-68bbf6c122ae/s1200?webp=false"},
        {id: 7, name: "Вин Бензин", img: "https://steamuserimages-a.akamaihd.net/ugc/775113851241543716/7335FB32DB2BF8385B916C647F93725B90B5535B/?imw=512&amp;imh=512&amp;ima=fit&amp;impolicy=Letterbox&amp;imcolor=%23000000&amp;letterbox=true"},
        {id: 8, name: "Вин Топливо", img: "https://avatars.mds.yandex.net/get-pdb/1350656/1551285a-c152-405f-9336-798ec54b07a9/s1200"},
        {id: 9, name: "Миша Тинькоф", img: "https://avatars.mds.yandex.net/get-pdb/1649566/19e74635-4319-4587-89bf-68bbf6c122ae/s1200?webp=false"},
        {id: 10, name: "Роберт Ап", img: "https://steamuserimages-a.akamaihd.net/ugc/775113851241543716/7335FB32DB2BF8385B916C647F93725B90B5535B/?imw=512&amp;imh=512&amp;ima=fit&amp;impolicy=Letterbox&amp;imcolor=%23000000&amp;letterbox=true"},
        {id: 11, name: "Игорь Пушкович", img: "https://avatars.mds.yandex.net/get-pdb/1649566/19e74635-4319-4587-89bf-68bbf6c122ae/s1200?webp=false"},
    ],
    messages: [],
    activeUser: null,
    isPreloader: false
};


const dialogsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MESSAGE:
            return {
                ...state,
                messages: action.message
            };
        case SEND_MESSAGE:
            return {
                ...state,
                messages: [...state.messages, {id: 7, text: action.text, isYouSend: true}]
            };
        case SET_ACTIVE_USER:
            return {
                ...state,
                activeUser: action.id
            };
        case TOGGLE_PRELOADER:
            return {
                ...state,
                isPreloader: action.isPreloader
            };
        default:
            return state
    }
};

const getMessageSuccess = (message) => ({type: SET_MESSAGE, message});
export const sendMessage = (text) => ({type: SEND_MESSAGE, text});
export const setActiveUser = (id) => ({type: SET_ACTIVE_USER, id});
export const togglePreloader = (isPreloader) => ({type: TOGGLE_PRELOADER, isPreloader});

export const getMessage = (id) => (dispatch) => {
    dispatch(getMessageSuccess([{id: 1, text: "Хэй бро, как твои дела?", sender: id},
        {id: 2, text: "Здарова, ты кто?", sender: null},
        {id: 3, text: "Я тот кто не ты", sender: id},
        {id: 4, text: "Я тоже рад, что ты не я", sender: null},
        {id: 5, text: "будь здоров, бро", sender: id},
        {id: 6, text: "пока", sender: id}]))
};


export default dialogsReducer